import fetchManager from '@utils/fetchManager'
import { getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getAllBlacklistDomains: async () => {
    const options = {
      sendToken: false
    }
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/process/domains`, options)
    return response
  },

  addtDomainToBlacklist: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/process/domains`, {
        method: 'POST',
        data,
      })
    return response
  },

  deleteDomain: async (domain) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/process/domains/${domain}`, {
        method: 'DELETE'
      })
    return response
  },
}
